module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"lt":{"departmentSite":"Padalinio svetainė"},"en":{"departmentSite":"Branch page"}}')
  delete Component.options._Ctor
}
